const storageKey = (changeSetId: string) => `chat-pending-import-exclusions:${changeSetId}`

export function readImportExclusions(changeSetId: string): ReadonlySet<number> {
  try {
    const stored = localStorage.getItem(storageKey(changeSetId))
    const parsed: unknown = stored ? JSON.parse(stored) : []
    return new Set(Array.isArray(parsed) ? parsed.filter((id): id is number => typeof id === 'number') : [])
  } catch {
    return new Set()
  }
}

export function writeImportExclusions(changeSetId: string, azureDevOpsIds: ReadonlySet<number>): void {
  try {
    if (azureDevOpsIds.size === 0) localStorage.removeItem(storageKey(changeSetId))
    else localStorage.setItem(storageKey(changeSetId), JSON.stringify([...azureDevOpsIds]))
  } catch {
    return
  }
}

export function clearImportExclusions(changeSetId: string): void {
  writeImportExclusions(changeSetId, new Set())
}
